import { Component, Input, OnChanges } from '@angular/core';
import { UserTableConstructorInfo } from 'src/app/interfaces/tables.interfaces';
import { PaginationComponentShared } from '../../../shared/pagination/pagination-component.shared';
import { ConnectionTableFactory } from '../../grid-table-factory';
import { RelationRequestTables } from '../../grid-table-factory/table-creator.enum';
import { ConnectionRequest } from '../../relation-request.interface';

@Component({
  selector: 'app-connections-list',
  templateUrl: './connections-list.component.html',
  styleUrls: ['./connections-list.component.scss'],
})
export class ConnectionsListComponent extends PaginationComponentShared implements OnChanges {
  @Input({ required: true }) public isLoading = false;
  @Input({ required: true }) public connections: ConnectionRequest[];

  public constructorData: UserTableConstructorInfo = { header: [], body: [], attribute: null };

  public ngOnChanges(): void {
    this.constructorData = new ConnectionTableFactory().buildTableConstructorData(
      RelationRequestTables.CONNECTION_LIST,
      this.connections,
    );
  }
}
